import {
  Col, Flex, Row, Space, Spin, Typography
} from "antd";
import "dayjs/locale/it";

import { useTranslation } from "react-i18next";
import classes from "./col.module.css";
import Appointment from "../Appointment";
import { AppointmentType } from "../../types/user";
import useAppointments from "../../hooks/useAppointments";

const {
  Title,
} = Typography;

const DoctorAppointments = () => {
  const { t } = useTranslation();
  const { appointments, loading } = useAppointments();

  return (
    <Flex vertical className={classes.root}>
      <Title level={3}>{t("dashboardPage.appointments.title")}</Title>
      <div className={classes.container}>
        {loading
          ? (
            <Flex justify="center" align="center" style={{ width: "100%", height: "100%" }}>
              <Spin />
            </Flex>
          ) : null}
        {appointments ? (
          <Row gutter={[16, 16]} className={classes.container}>
            {appointments.length === 0 ? (
              <Col span={24}>
                <Space direction="horizontal" size={0} style={{ width: "100%" }}>
                  {t("dashboardPage.appointments.noData")}
                </Space>
              </Col>
            ) : (
              appointments.map((appointment: AppointmentType) => (
                <Col span={24} key={appointment.id}>
                  <Appointment appointment={appointment} />
                </Col>
              ))
            )}
          </Row>
        ) : null}
      </div>
    </Flex>
  );
};

export default DoctorAppointments;
